/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BenutzerverwaltungProblemTypes = {
    BenutzerverwaltungFunktionsbereichNichtGefunden: 'BenutzerverwaltungFunktionsbereichNichtGefunden',
    BenutzerverwaltungFunktionsbereichGeloescht: 'BenutzerverwaltungFunktionsbereichGeloescht',
    BenutzerverwaltungFunktionsbereichKeinTitel: 'BenutzerverwaltungFunktionsbereichKeinTitel',
    BenutzerverwaltungBenutzerGeloescht: 'BenutzerverwaltungBenutzerGeloescht',
    BenutzerverwaltungBenutzerEntraKannNichtLoeschen: 'BenutzerverwaltungBenutzerEntraKannNichtLoeschen',
    BenutzerverwaltungHankoApiProblem: 'BenutzerverwaltungHankoApiProblem',
    BenutzerverwaltungBenutzerHatKeineMailAdresse: 'BenutzerverwaltungBenutzerHatKeineMailAdresse',
    BenutzerverwaltungBenutzerHatLogin: 'BenutzerverwaltungBenutzerHatLogin',
    BenutzerverwaltungBenutzerEntryIdBereitsEntkoppelt: 'BenutzerverwaltungBenutzerEntryIdBereitsEntkoppelt',
    BenutzerverwaltungBenutzerAzureAdOptionsFehlt: 'BenutzerverwaltungBenutzerAzureAdOptionsFehlt',
    BenutzerverwaltungBenutzerHatEntraDomain: 'BenutzerverwaltungBenutzerHatEntraDomain',
    BenutzerverwaltungBenutzerMitMailExistiertBereits: 'BenutzerverwaltungBenutzerMitMailExistiertBereits',
    BenutzerverwaltungRolleNichtGefunden: 'BenutzerverwaltungRolleNichtGefunden',
    BenutzerverwaltungRolleGeloescht: 'BenutzerverwaltungRolleGeloescht',
    BenutzerverwaltungKeinAdminOderFunktionsbereichAdmin: 'BenutzerverwaltungKeinAdminOderFunktionsbereichAdmin',
    BenutzerverwaltungBenutzerKeinFbAdminOderAdmin: 'BenutzerverwaltungBenutzerKeinFbAdminOderAdmin',
    BenutzerKeinMandantAdmin: 'BenutzerKeinMandantAdmin'
} as const;
export type BenutzerverwaltungProblemTypes = typeof BenutzerverwaltungProblemTypes[keyof typeof BenutzerverwaltungProblemTypes];

